const Seguinos = ({ marca, title }) => {
  return <p className={`subtitle ${marca}`}>{title}</p>;
};

export default Seguinos;
